<template>
    <div class="app has-header">
        <div class="header main">

            

            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
           
            
        </div>
        <div class ="tablecontainer scrollbar-container">
            <datatable :state="collectiveContractsTableState" v-if="!loading"/>
        </div>

       
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'collectivecontracts',
  data () {
    return {
      countryIdMap: {
        "1": "AT",
        "2": "DE",
        "8": "LU",
      },
      loading: false,
     }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  computed: {
    ...mapGetters(['storeId', 'collectiveContractMap', 'mlCollectiveAgreementMap', 'storeSettings', 'uiDataMap']),
    countryMap() {
        let map = {};
        this.uiDataMap.countries.forEach(item => map[item.id] = item.label_de);
        return map;
    },
    collectiveContractsTableState(){
        let view = this;
        let state = {};
            
        state = this.$helpers.GetDataTableStateFromObject({name: '', country: '', mlCollectiveAgreementId: ''}, Object.values(view.collectiveContractMap).sort((a,b) => {
            let res = a.country - b.country;
            if(res == 0){
                res = a.name.localeCompare(b.name);
                
            }
           
            return res;
        }));
        state.headerMap['name'].sort = true;
        state.headerMap['name'].align = 'center';
        state.headerMap['name'].label = this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel');
        state.headerMap['name'].DisplayLabel = (i) => {return i.name };
        state.headerMap['country'].sort = true;
        state.headerMap['country'].align = 'center';
        state.headerMap['country'].label = this.$t('pages.employeeCoreData.country');
        state.headerMap['country'].DisplayLabel = (i) => {return view.countryMap[i.country]};
        state.headerMap['mlCollectiveAgreementId'].sort = false;
        state.headerMap['mlCollectiveAgreementId'].align = 'center';
        state.headerMap['mlCollectiveAgreementId'].label = this.$t('store.collectiveContracts.mlData');
        state.headerMap['mlCollectiveAgreementId'].DisplayLabel = (i) => {return view.mlCollectiveAgreementMap[i.mlCollectiveAgreementId] != null ? (view.mlCollectiveAgreementMap[i.mlCollectiveAgreementId].name+' ('+view.countryIdMap[view.mlCollectiveAgreementMap[i.mlCollectiveAgreementId].countryId]+')') : ''};
       
        
            
            
        state.headerMap['actions'] = {align: 'center',
            buttons:[
                {icon: 'fas fa-edit', action: ($event, data) => view.EditCollectiveContract($event, data)}, 
                
            ]
        };
        state.headerMap['actions'].width = '100px';
        return state;
    },
    headerButtons(){

        let view = this;

        let state= {
            buttons: []
        };
        //BUTTON 1
                
        
                    
                
        state.buttons.push({
            type: "block",
            icon: "fa-sync-alt",
            click: () => {
                    view.refresh(true);  
            },
            tooltip: this.$t('global.general.refreshData')
        });
        
        state.helperLinks = [
            {
                title:  this.$t('store.structure.getSupport'),
                helperText:  this.$t('store.structure.getSupportHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                externalLabel:  this.$t('store.structure.getSupportLabel'),
                cancelLabel: this.$t('global.ui.close'),
            }
        ];
        return state;
    },
  },
  watch: {
    
    storeId: function(val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        view.$helpers.GetCollectiveContractMap(true)
        .then(response => {
            view.$helpers.GetMlCollectiveAgreementMap(true);
        }).catch(function (error) {
            console.log(error);
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
        })

    },
    
    EditCollectiveContract($event, contract){
        let view = this;
        let validMlCollectiveAgreements = Object.values(view.mlCollectiveAgreementMap).filter(ca => ca.countryId == contract.country).map(ca => {return {id: ca.id, label: ca.name, value: ca.id}});
        let selectedMlCollectiveAgreement = validMlCollectiveAgreements.find(ca => ca.id == contract.mlCollectiveAgreementId);
        if(selectedMlCollectiveAgreement != null){
            selectedMlCollectiveAgreement.selected = true;
        }

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: 'Id', key: 'id', hidden: true, type: '', value: contract.id},
                    {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: contract.name},
                    {label: this.$t('store.collectiveContracts.mlData'), key: 'mlCollectiveAgreementId', hidden: false, type: 'dropdownsearch', value: contract.mlCollectiveAgreementId, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: validMlCollectiveAgreements,
                            selectMultiple: false,
                            selectedItems: selectedMlCollectiveAgreement != null ? [selectedMlCollectiveAgreement] :  [],
                            selectFirst: false,
                            styleLight: true,
                    }},
                    
                ],
                width: "500px",
                selectCallback: function (item) {
                    view.updateCollectiveContract(item);
                }
            },
            header: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' Basis Daten bearbeiten',
            expanded: true,
            centered: true
        });
    },
    updateCollectiveContract(item) {
        let view = this;
        let url = '/api/semi/collectivecontract';
        
        let params = {
            storeId: this.$store.state.storeId,
        };
        
        let payload = {
            id: item.id,
            name: item.name,
            mlCollectiveAgreementId: item.mlCollectiveAgreementId,
            updateFields: ["name", "mlCollectiveAgreementId"]
        }
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            let cc = view.collectiveContractMap[item.id];
            cc.name = item.name;
            cc.mlCollectiveAgreementId = item.mlCollectiveAgreementId;
            

            view.$set(view.collectiveContractMap, ''+cc.id, cc);
            view.$store.commit("invalidateState", {states: ["employeeTypeTemplateMapState", "employeeTypeMapState", "allowedContractMapState"]});
            view.$helpers.success(view.$t('global.notifications.success'), (view.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' Basis Daten wurde erfolgreich aktualisiert');
        }).catch(function (error) {    
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
        })
    },
    
    
    
    
  },

}
</script>


<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .loading{

        -webkit-filter: none !important;
        filter: none !important;
        position: absolute;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        bottom: 0;
        left: 0;
        top: initial;
        width: 100%;
        height: calc(100vh - 109px);
        background: rgba(0,0,0,.5);
        z-index: 10;
        position: fixed;
    }

    .header > .header.date{
        width: fit-content;
    }

    .paging{
        top: 0;
        bottom: 0;
        right: 250px;
    }

    .header > .text-filter{
        top: 0;
        bottom: 0;
        width: 230px;
        right: 45px;
    }

</style>
